<template>
    <div class="program">
        <div class="info">{{program.date_time}}<span v-if="program.channel"> | {{program.channel}}</span></div>
        <div class="title">{{ program.title }}</div>
        <div class="sub-title" v-if="program.title_alt">{{ program.title_alt }}</div>
        <div
            class="members"
            v-for="person in membersOnShow"
            :key="person.id"
            :style="{color: `${person.color}`, fontWeight: `bold`}"
        >
            {{person.name}}
        </div>
    </div>
</template>

<script>
import profile from '@/data/profile.js';

export default {
    name: 'Program',
    props: ["program",],
    computed: {
        membersOnShow: function() {
            let list = [];
            const memberIDs = this.program.members;
            for ( const memberID of memberIDs ) {
                const person = profile[memberID];
                list.push(person);
            }
            if ( list.length === 5 ) {
                list = [{
                    id: 'a',
                    name: '아라시',
                    color: '#2c3e50',
                }];
            }
            return list;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';
.program {
    max-width: 800px;
    width: 500px;
    margin: 10px auto;
    padding: 5px;
    box-sizing: border-box;
    border: 2px dotted $light;
}
.info {
    font-size: 14px;
    color: $light;
}
.title {
    font-size: 22px;
    font-weight: 900;
    margin: 8px 0 -3px;
}
.sub-title {
    color: $light;
    margin-bottom: 8px;
}

</style>
